import React from "react"

import {AppAsyncOfficesAutocomplete} from "@components"
import { useUserSettingsOfficesGroup, useUserSettingsOfficesGroupValidator } from "../../@hooks"
import { userSettingsOfficesGroupFormData } from "../../@signals"


export default function UserSettingOfficesGroupDrawerOffices() {
	const { handleChangeOfficesGroupFormData } = useUserSettingsOfficesGroup()
	const { officesError } = useUserSettingsOfficesGroupValidator()

    return <AppAsyncOfficesAutocomplete
		multiple
		placeholder="Select office(s)"
		error={officesError}
		value={userSettingsOfficesGroupFormData.value?.offices || []}
		onChange={e => handleChangeOfficesGroupFormData(e.target.value, 'offices')}
	/>
}